import type { FC } from "react";
import { CardContent, EmptyFeaturePage } from "../../../core/components";
import cameraKitIcon from "../../assets/common/camera-kit-icon.svg";
import { Image } from "./Image";
import { unauthorizedImageWrapperStyle, unauthorizedMessageStyle } from "./CamkitUnauthorizedCard.styles";
import { cx } from "@emotion/css";

const unauthorizedMessage = (
    <>
        <p>Camera Kit is now generally available! To continue, please have an organization admin visit this page.</p>
    </>
);

export const CamkitUnauthorizedCard: FC = () => {
    return (
        <EmptyFeaturePage
            title="Get Started With Camera Kit"
            icon={
                <Image
                    dataTestId="camera-kit-no-auth-icon"
                    className={cx("camkit-icon", unauthorizedImageWrapperStyle)}
                    src={cameraKitIcon}
                    alt="Camera Kit"
                    widthPx={150}
                    heightPx={150}
                />
            }
            status={null}
        >
            <CardContent alignItems="flex-start" data-testid="camera-kit-no-auth-content">
                <div className={unauthorizedMessageStyle}>{unauthorizedMessage}</div>
            </CardContent>
        </EmptyFeaturePage>
    );
};
